import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-gt.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-gt.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationDetailsGtConstants } from "./create-application-details-gt.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { take, takeUntil } from "rxjs/operators";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
let CreateApplicationDetailsGtComponent = class CreateApplicationDetailsGtComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsGtConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = CreateApplicationDetailsGtConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = CreateApplicationDetailsGtConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    fileNumberFormControlName = CreateApplicationDetailsGtConstants.FILE_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = CreateApplicationDetailsGtConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsGtConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addApplicationTypeLabel = CreateApplicationDetailsGtConstants.ADD_APPLICATION_TYPE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsGtConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = CreateApplicationDetailsGtConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = CreateApplicationDetailsGtConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    fileNumberLabel = CreateApplicationDetailsGtConstants.FILE_NUMBER_LABEL;
    applicationTypes = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    loadMetadata(stepMeta) {
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType' and deleted eq false)`
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsGtConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.changeDetectorRefs.detectChanges();
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddApplicationTypeClicked() {
        const applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            type: new FormControl(null, [Validators.required])
        });
        applicationTypesControl.push(typeGroup);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsGtComponent = __decorate([
    Component({
        selector: "app-create-application-details-gt",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsGtComponent);
export { CreateApplicationDetailsGtComponent };
